import NotificationAlertImpersonate from 'molecules/NotificationAlertImpersonate';
import { GetServerSidePropsContext } from 'next';
import getConfig from 'next/config';
import { NextSeo } from 'next-seo';
import React from 'react';
import { store, StoreContext } from 'stores/store';
import MarketplaceWrapper from 'templates/Marketplace/MarketplaceWrapper';
import { SSRCookies } from 'utils/cookies';
import UseSsrAuth from 'utils/hooks/useSsrAuth';

const { publicRuntimeConfig } = getConfig();
const { NEXT_PUBLIC_DOMAIN } = publicRuntimeConfig;

export default function MarketplacePage({ assetBrowsingView }: { assetBrowsingView?: string }) {
  const title = 'USREM - Liquidity for Real Estate | Secondary Real Estate Investment Marketplace';
  const url = `https://${NEXT_PUBLIC_DOMAIN}/marketplace`;
  const description =
    'USREM’s marketplace enables investors to buy and sell fractions of residential and commercial real estate properties, with the sponsors’ blessing.';
  const image =
    'https://www.usremsecurities.com/wp-content/uploads/2022/04/USREM-Website-Cover-image-Apr22.jpg';

  return (
    <>
      <NextSeo
        noindex
        nofollow
        additionalMetaTags={[
          {
            property: 'image',
            content: image
          }
        ]}
        title={title}
        canonical={url}
        openGraph={{
          title: title,
          url: url,
          description,
          images: [
            {
              url: image,
              alt: 'USREM | Liquidity for Real Estate',
              type: 'image/jpeg'
            }
          ]
        }}
      />
      <StoreContext.Provider value={{ ...store, cookie: { value: assetBrowsingView } }}>
        <>
          <MarketplaceWrapper />
          <NotificationAlertImpersonate />
        </>
      </StoreContext.Provider>
    </>
  );
}

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const authProps = await UseSsrAuth(ctx);
  const configProps = SSRCookies(ctx.req, ctx.res, 'assetBrowsingView');
  const headerConfig = { isCompoundHeader: true };

  return { props: { ...configProps.props, ...authProps.props, headerConfig } };
}
